/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class PersonRequest extends MainRequest{

     static update(object) {
        return this.postSEC(ServicePath.PERSON_UPDATE_PROFILE, object);
     }


 }